import Swiper from 'swiper';
import { Navigation, EffectFade, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/effect-fade';

export default function (element, data) {
    element.swiper = new Swiper(element, {
        modules: [Navigation, EffectFade, Autoplay, Pagination],
        slidesPerView: 1,
        effect: "fade",
        speed: data.transition || 1000,
        loop: true,
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: data.timeout || 4000,
        },
        pagination: {
            el: element.querySelector(".swiper-pagination"),
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: element.querySelector(".swiper-button-next"),
            prevEl: element.querySelector(".swiper-button-prev"),
        },
    });
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary